import React from 'react';
export const useModalSlideoutScroll = () => {
    const [isScrolledToTop, setIsScrolledToTop] = React.useState(() => true);
    const handleScroll = React.useCallback((e) => {
        const fromTop = 16;
        if (e.currentTarget.scrollTop < fromTop && !isScrolledToTop) {
            setIsScrolledToTop(true);
        }
        else if (e.currentTarget.scrollTop >= fromTop && isScrolledToTop) {
            setIsScrolledToTop(false);
        }
    }, [isScrolledToTop]);
    const handleResetScroll = () => setIsScrolledToTop(true);
    return { isScrolledToTop, handleScroll, handleResetScroll };
};
